import {Configuration, LogLevel, PopupRequest} from "@azure/msal-browser";

export const getMsalConfig = (host:string) => {
    const retval: Configuration = {
        auth: {
            clientId: "7680cd50-c02e-49eb-afba-91d6bc9d7559",
            authority: "https://login.microsoftonline.com/df63f0ef-ef42-4325-96af-cae6892d1caa", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
            redirectUri: `${host}/auth.html`,


        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        }

    }
    return retval;
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["https://vscserver.bimaire.com/Content.Read"],


};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


